export * from './Label';

export { default } from './Label';
